import { render, staticRenderFns } from "./SCardPaymentComp.vue?vue&type=template&id=3d4d59fb&"
import script from "./SCardPaymentComp.vue?vue&type=script&lang=js&"
export * from "./SCardPaymentComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports